/**
 * Centralised locale-restriction config and predicates.
 *
 * Two scopes:
 *   slugs      – gate entire pages (PageResolver redirects to / if not allowed)
 *   components – gate individual sections within a renderer (returns null)
 *
 * Keys are lowercase. Locale values are case-insensitive on comparison.
 */

export const localeRestrictions = {
  slugs: {
    "set-up-and-activate-your-netflix-campaign": ["en-US"],
  } as Record<string, readonly string[]>,

  components: {} as Record<string, readonly string[]>,
};

const normalize = (value: string) => value.trim().toLowerCase();

export const isLocaleAllowed = (
  locale: string,
  allowedLocales?: readonly string[]
): boolean => {
  if (!allowedLocales || allowedLocales.length === 0) return true;
  const n = normalize(locale);
  return allowedLocales.some((l) => normalize(l) === n);
};

export const isSlugAllowedForLocale = (
  slug: string,
  locale: string
): boolean => {
  const allowed = localeRestrictions.slugs[normalize(slug)];
  return isLocaleAllowed(locale, allowed);
};

export const isComponentAllowedForLocale = (
  componentKey: string,
  locale: string
): boolean => {
  const allowed = localeRestrictions.components[componentKey];
  return isLocaleAllowed(locale, allowed);
};
